export default "__VITE_ASSET__Bnk6LAS6__"